import { apiDomain } from "../constants";
import axios from "../myaxios";

export const getMessages = async (page = 1, pageSize = 20) => {
    return await axios.get(`${apiDomain}clients/request-client/?page=${page}&page_size=${pageSize}`);
}

export const sendMessage = async ({ message }) => {
    return await axios.post(`${apiDomain}clients/request-client/`, message);
}